import {map, orderBy} from 'lodash';

import ChartConstants from 'components/Chart/Constants';
import BarChart from 'components/Chart/LazyBar';
import Loading from 'components/Loading';
import KyError from 'components/errors/KyError';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';

export default function VariantAnnotationsBarChart() {
  const appContext = useAppContext();

  const {response, error} = useGet('site/stat/variantAnnotations', {
    cacheResponse: !appContext.isPreview,
  });

  let barChart = (
    <div className="laFigure laFigure--loading figure">
      <Loading />
    </div>
  );

  if (error) {
    barChart = <KyError kyError={error} />;
  } else if (response) {
    const vaTypeCountArray = orderBy(response.data, (d) => d[1], 'desc');
    const data = map(vaTypeCountArray, (typeCount) => ({label: typeCount[0], value: typeCount[1]}));
    barChart = (
      <div>
        <BarChart
          data={data}
          showLabels={true}
          horizontal={true}
          yAxisLabel={{truncate: ChartConstants.truncateOptions.MIDDLE, maxLength: 60}}
        />
        <figcaption className="text-center text-muted">
          Counts of variant annotations by type.<br /><em>NOTE:</em> variant annotations may be assigned more than one type.
        </figcaption>
      </div>
    );
  }

  return barChart;
}
